import {
    Avatar,
    Collapse,
    Link,
    Table, TableBody, TableCell,
    TableHead,
    TableRow, Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import axios from "axios";
import ContactsAccoladesSectionAddModal from "./ContactsAccoladesSectionAddModal";

const useStyles = makeStyles((theme) => ({
    contentSection: {
        padding: '16px 22px',
        background: '#fff',
        marginBottom: '15px',
        borderRadius: '3px',
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionHeaderTitle: {
        fontSize: '17px',
        fontWeight: '600',
        color: '#000',
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    form: {
        height: '100%',
    },
    field: {
        '& label.Mui-focused': {
            color: '#000',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#000',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#000',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#000',
            },
        },
    },
    tabActive: {
        color: '#1E69E5',
    },
    associationLink: {
        position: 'absolute',
        top: '-10px',
        right: '10px',
        cursor: 'pointer',
        decoration: 'none',
        '&:hover': {
            decoration: 'none',
        }
    },
    inheritFontWeight: {
        fontWeight: 'inherit',
    },
    tableMarginTop: {
        marginTop: 24,
    },
}));

const ContactsAccoladesSection = (props) => {
    const classes = useStyles()
    const {contact, tab, handleTabChange} = props
    const [accolades, setAccolades] = useState([])
    const [openAddAccoladeForm, setOpenAddAccoladeForm] = useState(false)

    useEffect(() => {
        getAccolades()
    }, [])

    const getAccolades = () => {
        const crdId = contact.contact_crd_id
        axios.get(
            '/v1/admin/contacts_accolades/accolades_by_crd_id',
            {
                params: {crd_id: crdId},
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': props.adminUserSession.email,
                    'X-Admin-User-Token': props.adminUserSession.token
                }
            }
        ).then((response) => {
            const {accolades} = response.data;
            setAccolades(accolades)
        });
    }

    const headCells = [
        {id: 'id', label: 'Id'},
        {id: 'logo', label: 'Logo'},
        {id: 'outlet', label: 'Outlet'},
        {id: 'description', label: 'Accolade'},
        {id: 'year', label: 'Year'},
        {id: 'crd_ids', label: 'Associated Contacts'},
    ];

    const handleRemoveItem = (event, id) => {
        const crdId = contact.contact_crd_id
        axios.put(
            '/v1/admin/contacts_accolades/update_crd_ids',
            {
                params: {id: id, crd_id: crdId, remove: true},
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Admin-User-Email': props.adminUserSession.email,
                    'X-Admin-User-Token': props.adminUserSession.token
                }
            }
        ).then((response) => {
            getAccolades()
        });
    }

    const renderRow = (props) => {
        return (
            <TableRow hover key={props.id}>
                <TableCell>{props.id}</TableCell>
                <TableCell>
                    <Avatar src={props.logo.url}
                            alt={props.outlet}>{props.outlet?.[0]}
                    </Avatar>
                </TableCell>
                <TableCell>{props.outlet}</TableCell>
                <TableCell>{props.description}</TableCell>
                <TableCell>{props.year}</TableCell>
                <TableCell>{props.crd_ids ? props.crd_ids.length : 0}</TableCell>
                <TableCell>
                    <Link to='' onClick={(event) => handleRemoveItem(event, props.id)}>Remove</Link>
                </TableCell>
            </TableRow>
        )
    }

    const onCloseModal = () => {
        setOpenAddAccoladeForm(false)
        getAccolades()
    }

    return (
        <React.Fragment>
            <div className={classes.contentSection}>
                <div className={classes.contentSectionHeader}
                     onClick={(event) => handleTabChange(event, 'newAccolade')}>
                    <Typography variant='h5'
                                className={`${classes.contentSectionHeaderTitle} ${tab === 'newAccolade' ? classes.tabActive : ''}`}>Accolades</Typography>
                    {tab === 'newAccolade' ? <ExpandLess/> : <ExpandMore/>}
                </div>
                <Collapse in={tab === 'newAccolade'}>
                    <div className={classes.contentSectionContent}>
                        <div className={classes.formGroup}>
                            <div style={{cursor: 'pointer'}} onClick={() => setOpenAddAccoladeForm(true)}>Add Accolade</div>
                            {accolades ? <Table className={classes.tableMarginTop}>
                                <TableHead>
                                    <TableRow>
                                        {headCells.map((headCell) => (
                                            <TableCell key={headCell.id}>
                                                {headCell.label}
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {accolades == undefined ?
                                        <TableRow><TableCell>Loading...</TableCell></TableRow> : accolades.map(renderRow.bind(this))}
                                </TableBody>
                            </Table> : null}
                        </div>
                    </div>
                </Collapse>
            </div>
            {openAddAccoladeForm ?
                <ContactsAccoladesSectionAddModal
                    contact={contact}
                    onClose={onCloseModal}
                    adminUserSession={props.adminUserSession}/>
                : null
            }
        </React.Fragment>
    )
}

export default ContactsAccoladesSection;